import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './Drawer.scss';

/**
 * Reusable Drawer Component
 * @function Drawer
 * @param {Object}
 * @return {ReactElement}
 */
const Drawer = ({ children, className, contentClassName, contentStyle, style }) => {
  return (
    <div className={classNames(styles.drawer, className)} style={style}>
      <div className={classNames(styles.drawerContent, contentClassName)} style={contentStyle}>
        {children}
      </div>
    </div>
  );
};

Drawer.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  contentStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default Drawer;
